<div class="d-flex justify-content-between align-items-center">
    <h5 class="mb-0">Accounts</h5>
    <!-- <button class="primary solid-gradient-btn btn-custom" (click)="comingSoon()">Log out</button> -->
</div>
<mat-dialog-content>
    <div class="mt-4">
        <hr style="border: 0.5px solid">
        <div *ngFor="let acc of addressList; let i = index">
            <div class="media mb-3 modalacc" (click)="selectAddress(i)" style="cursor:pointer"  [class.selectedAcc]="acc == this.helper.accountList[this.helper.slectedAddress]">
                <!-- <img src="../../assets/images/user.png"> -->
                <i class="fa fa-user mr-2" aria-hidden="true"></i>

                <div>
                    <div class="d-flex flex-wrap w-100">
                        <h4 class="w-100 mb-2">Account {{i+1}}</h4>
                        <div class="d-flex justify-content-between w-100" >
                            <h6>{{acc | slice:0:10}}...</h6>
                            <h6>{{BalanceList[acc] | number:'2.8'}} </h6>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="media mb-3" *ngIf="acc!=this.helper.accountList[this.helper.slectedAddress]">
                <img src="../../assets/images/user_inactive.png" class="mr-2">
                <div>
                    <h4 style="color:yellow; margin-bottom: 0;">Account {{i+1}}</h4>
                    <h6>{{i.next().value | slice:0:10}}...</h6>
                </div>
            </div> -->
        </div>
        <hr style="border: 0.5px solid">
        <div class="media mb-3 addAcc">
            <i class="fa fa-plus mr-2"></i>
            <h6 class="mb-3" (click)="AddAccount()" style="cursor: pointer" >New Account</h6>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-between align-items-center">
        <button mat-stroked-button class="primary solid-gradient-btn" (click)="route('export')" title="Export Account">Export</button>
        <button mat-stroked-button  class="primary solid-gradient-btn" (click)="removeWallet()"  title="Remove Wallet">
        <i class="fa fa-trash" aria-hidden="true" style="font-size: x-large;"></i>
        </button>

    <!-- </button>
    <div class="media ">
            <img src="../../assets/images/paper-bin.png">
        </div> -->
</mat-dialog-actions>
